import React, {memo} from "react";
import swal from 'sweetalert';
import {FaInfoCircle} from "react-icons/all";

const TitlesModals = (props) => {
    const {text, title} = props.swal !== undefined ? props.swal : {text: 'متن راهنما', title: 'راهنما'};
    const handelSwalAlert = () => {
        swal({
            title: title,
            text: text,
            buttons: {
                cancel: "تایید",
            },
            icon: "info",
        });
    };
    return (
        <div className={'base-box-titles-modals'}>
            <div className={'box-titles-address-modals'}>
                <h6 className={'title-address-modals'}>{props.children}</h6>
                {props.swal !== undefined ?
                    <div className={'box-info-title-modals'}>
                        <FaInfoCircle className={'icon-header-titles-info'}
                                         onClick={handelSwalAlert}/>
                    </div>
                    : ''}
            </div>
        </div>
    );
};

export default memo(TitlesModals);
